// extracted by mini-css-extract-plugin
export default {"content-switcher":"DL0wtr"};